import { render } from "./RowComponent.vue?vue&type=template&id=88448e6e"
import script from "./RowComponent.vue?vue&type=script&lang=js"
export * from "./RowComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__